module.exports = __webpack_public_path__ + "img/f1.a4c9350a.png";